export default "__VITE_ASSET__DUv0Cqqc__"